/** Keeps "return early" disabled across menu remounts while the absence update still runs. */
export const UPDATE_USER_ABSENCE_MUTATION_KEY = 'topBarUpdateUserAbsence';
